'use client';

import React, { useCallback } from 'react';
import CheatAction from 'components/CheatAction';
import toast from 'react-hot-toast';
import { Copy } from 'lucide-react';
import { Example } from '@/types/Example';

interface CopyExampleButtonProps {
  cheat: Example;
}

const CopyExampleButton = (props: CopyExampleButtonProps) => {
  const { cheat } = props;

  const handleCopyCommand = useCallback(() => {
    navigator.clipboard.writeText(cheat?.example || '');
    toast.success('Copied!');
  }, [cheat]);

  return (
    <CheatAction onClick={handleCopyCommand} tooltip="Copy command">
      <Copy size={18} aria-label="Copy command" />
    </CheatAction>
  );
};

export default CopyExampleButton;
